import { LitElement } from '~/lib/bn-lit-element';
import { css, html, renderIf } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import './import-mapping-target';

class ImportMappingTargetGroup extends LitElement {
  static get properties() {
    return {
      name: { type: String },
      recordPreview: { type: Object },
      targets: { type: Array },
      readonly: { type: Boolean },
      hideGroupName: { type: Boolean, attribute: 'hide-group-name' },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      .targets {
        display: flex;
        margin-bottom: 0.3em;
        flex-flow: wrap;
      }
      import-mapping-target {
        margin-right: 0.5em;
        width: 16rem;
      }
    `];
  }

  render() {
    if (!this.targets) {
      return html``;
    }
    return html`
      ${renderIf(!this.hideGroupName, html`
        <label>${this.name}</label>
      `)}
      <div class="targets">
        ${this.targets.map((target) => html`
          <import-mapping-target
            .entity="${target}"
            .recordPreview="${this.recordPreview}"
            ?readonly="${this.readonly}"
          ></import-mapping-target>
        `)}
      </div>
    `;
  }
}

window.customElements.define('import-mapping-target-group', ImportMappingTargetGroup);
